import React, { useRef } from 'react';
import '../graphStyles.scss';
import NoDataFound from "../../NoDataFound";
import { ExportDropdown } from "../../ExportDropdown";
import DateRangeFilter from "../DateRangeFilter/DateRangeFilter";
import useDateRangeFilter from "../DateRangeFilter/useDateRangeFilter";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const InfoIcon = ({ tooltipText }) => (
  <span className="info-tooltip-container">
    <svg className="info-tooltip-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
    <span className="info-tooltip-bubble">{tooltipText}</span>
  </span>
);

export function NumberOfUniqueVisitorsGraph({ uniqueBrowsers, engaged, weeks, display }) {
  const chartRef = useRef(null);


  const { filteredWeeks, filteredData, onFilterChange } = useDateRangeFilter({
    weeks,
    dataArrays: { uniqueBrowsers, engaged },
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
            },
          },
        },
        onHover: function (event, legendItem) {
          document.getElementById("chart").style.cursor = 'pointer';
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart").style.cursor = 'default';
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: 'Week',
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 10 : 13;
            },
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
            },
          },
        },
      },
      y: {
        title: {
          display: true,
          text: 'Number of users',
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 10 : 13;
            },
          },
        },
        ticks: {
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
            },
          },
        },
      },
    },
  };

  const labels = filteredWeeks;

  const data = {
    labels,
    datasets: [
      {
        label: 'Engaged',
        data: filteredData.engaged,
        backgroundColor: 'rgba(0, 50, 248, 0.83)',
        hoverBackgroundColor: 'rgba(0, 50, 248, 0.83)',
      },
      {
        label: 'Total',
        data: filteredData.uniqueBrowsers,
        backgroundColor: 'rgba(0, 230, 248, 0.95)',
        hoverBackgroundColor: 'rgba(0, 230, 248, 0.95)',
      },
    ],
  };

  const allData = [
    ["Metric", ...filteredWeeks],
    ["Number of visitors engaged", ...filteredData.engaged],
    ["Total Visitors", ...filteredData.uniqueBrowsers],
  ];

  return (
    <div className="graph">
      <div className="graph__title flex flex-col md:flex-row justify-between items-center">
        <h4 className="text-lg md:text-xl font-semibold text-center md:text-left mb-2 md:mb-0 flex items-center gap-1.5 justify-center md:justify-start">
          <span>Number of unique visitors</span>
          <InfoIcon tooltipText="Shows the count of total website visitors and how many of them engaged with the page." />
        </h4>
        <div className="flex items-center gap-2 flex-wrap justify-end pr-3">
          <DateRangeFilter weeks={weeks} onFilterChange={onFilterChange} />
          <ExportDropdown
            data={allData}
            chartRef={chartRef}
            name="Number of Unique Visitors"
          />
        </div>
      </div>

      {weeks.length === 0 ? (
        <NoDataFound />
      ) : (
        <div className="relative w-full h-64 md:h-96">
          <Bar
            ref={chartRef}
            className={`chart ${display === "dashboard" ? "dashboard__graph" : ""}`}
            id="chart"
            options={options}
            data={data}
          />
        </div>
      )}
    </div>
  );
}
